import axios from "@/plugins/axios";

// Pendapatan Isi Rumah Bulanan Purata — pulls aggregated income from the per-
// survey-year summary tables (ClickHouse `lampiran_hid_summary_<YEAR>`). Year
// columns are discovered server-side from the table list and returned in
// `data.years`; each row carries a per-year `values` map keyed by those years.
export default class pendapatanPurataServices {
  // params: { NG?, DP?, P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW" weighting) }
  async getPendapatanPurata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPendapatanPurataLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
